<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">전자 계약</span>
            <span class="txt">
                발송한 계약서 내역을 확인하고, 자주 쓰는 템플릿(서식)을 등록하거나 수정할 수 있습니다.
            </span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div class="com-tab">
                <span v-for="(item, index) in submenus" :key="index">
                    <router-link
                        v-show="item.valid"
                        :class="{ on: $route.name == item.name }"
                        :to="{ ...item, params: { centerId } }"
                    >
                        {{ item.label }}
                    </router-link>
                </span>
            </div>

            <table class="com-table left" style="margin-top: 30px">
                <colgroup>
                    <col style="width: 60px" />
                    <col style="width: 500px" />
                </colgroup>
                <tbody>
              <tr style='display: none'>
                        <th>기간</th>
                        <td>
                            <div class="com-calendar-wrap">
                                <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                                <div class="com-dash"><span class="dash">~</span></div>
                                <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                                <select-form
                                    style="margin-left: 10px"
                                    :select-data="['오늘', '어제', '이번달', '지날달', '3개월', '6개월', '12개월']"
                                    :select-value="[
                                        'today',
                                        'yesterday',
                                        'thisMonth',
                                        'prevMonth',
                                        'threeMonth',
                                        'sixMonth',
                                        'year',
                                    ]"
                                    :selected-value="period"
                                    @update:set="(val) => periodc(val)"
                                ></select-form>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>검색어</th>
                        <td>
                            <div class="com-calendar-wrap">
                                <select-form
                                    style="margin-right: 10px"
                                    :select-data="['계약서명', '내용']"
                                    :select-value="[1, 3]"
                                    :selected-value="searchDivision"
                                    @update:set="(val) => setSearchDivision(val)"
                                ></select-form>
                                <input
                                    v-model="searchStr"
                                    placeholder=""
                                    type="text"
                                    style="width: 400px"
                                    v-on:keyup.enter="onEventSearch"
                                />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>계약서 유형</th>
                        <td>
                            <div class="com-calendar-wrap">
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchMethod == '' ? 'active' : ''}`"
                                    @click="onSearchMethod('')"
                                >
                                    전체
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchMethod == 'P' ? 'active' : ''}`"
                                    @click="onSearchMethod('P')"
                                >
                                    직원
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchMethod == 'M' ? 'active' : ''}`"
                                    @click="onSearchMethod('M')"
                                >
                                    회원
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchMethod == 'E' ? 'active' : ''}`"
                                    @click="onSearchMethod('E')"
                                >
                                    기타
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="bottom-btn" style="margin-top: 20px">
                <button class="com-btn" @click="onSearch">검색</button>
                <button class="com-btn border-button general-button big" @click="onConditionInit">조건 초기화</button>
            </div>

            <div class="com-table-content">
                <div class="table-top-container">
                    <div class="left-box">
                        <p class="table-top-title"><strong>템플릿 목록</strong></p>
                    </div>
                    <div class="right-box">
                        <span class="table-top-count" style="margin-right: 10px">
                            총
                            <span class="blue">{{ templateListPagingInfo.totalItems }}</span>
                            개
                        </span>
                        <a class="com-btn red" style="margin-right: 10px" @click="deleteDocument">삭제</a>
                        <a class="com-btn blue" @click="registerDocument">등록</a>
                    </div>
                </div>

                <div style="margin-bottom: 20px" v-show="copiedList.length > 0">
                    <span>복사된 항목명:</span>
                    <span v-for="(c, ci) in copiedList">
                      {{templateList[c.index].e_contract_title + (c.count > 1 ? ("(" + c.count + ")") : "") + (ci < copiedList.length - 1 ? "," : "")}}
                    </span>
                </div>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 100px" />
                        <col style="width: 150px" />
                        <col style="width: 100px" />
                        <col style="width: 300px" />
                        <col style="width: 150px" />
                        <col style="width: 155px" />
                        <col style="width: 170px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                                <div class="com-check">
                                    <input
                                        id="check-all"
                                        v-model="selectedAll"
                                        name="check-all"
                                        type="checkbox"
                                        @click="checkedAll"
                                    />
                                    <label for="check-all"></label>
                                </div>
                            </th>
                            <th>
                                <button
                                    :class="
                                        templateListSortColumn == 'e_upd_dt' && templateListSortType == 'DESC'
                                            ? ''
                                            : 'degree'
                                    "
                                    @click="onClickSendDt"
                                >
                                    수정일시
                                </button>
                            </th>
                            <th>구분</th>
                      <th>계약서명</th>
                            <th>
                                다운로드
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <p class="txt">
                                            템플릿을 다운받아 서면 계약으로 진행할 경우 계약서 관리 내역에서는 확인이
                                            불가능합니다.
                                        </p>
                                    </div>
                                </div>
                            </th>
                            <th>
                                사용유무
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <p class="txt">
                                            템플릿 사용여부에 따라 전자계약 발송에서 해당 템플릿 목록이
                                            노출/숨김처리되어 나타납니다.
                                        </p>
                                    </div>
                                </div>
                            </th>
                            <th>관리</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(t, i) in templateList" :key="i">
                            <td>
                                <div class="com-check">
                                    <input :id="t.e_id" v-model="selected" :value="i" name="check-1" type="checkbox" />
                                    <label :for="t.e_id"></label>
                                </div>
                            </td>
                            <td>
                                {{ t.e_upd_dt | timestampFilter2 }}
                            </td>
                            <td>
                                {{ t.e_contract_member_type | getContractMemberType }}
                            </td>
                            <td>
                          <div style='width: 35vw; margin-left: auto; margin-right: auto'>
                              <div class='line-blind' style=' text-decoration: underline; cursor: pointer'
                                   @click='onShowContract(i)'>{{t.e_contract_title}}</div>
                          </div>
                            </td>
                            <td>
                                <button class="com-btn" @click="onDownloadDocument(i)">다운로드</button>
                            </td>
                            <td>
                                <div class="com-design-check">
                                    <input
                                        :id="`agree-${i}`"
                                        ref="refCheckAgree"
                                        :checked="t.e_use_yn"
                                        :name="`agree-name-${t.e_id}`"
                                        type="checkbox"
                                        @change="onSaveUseState(i, $event.target.checked)"
                                    />
                                    <label :for="`agree-${i}`"></label>
                                </div>
                            </td>
                            <td>
                                <button class="com-btn white" @click="onCopy(i)">복사</button>
                                <button class="com-btn" @click="onModify(i)">수정</button>
                            </td>
                        </tr>
                        <tr v-if="templateList.length === 0">
                            <td colspan="100">등록된 내역이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
                <div class="com-btn-area table-bottom-func">
                    <div class="left-box">
                        <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
                    </div>
                    <div class="right-box">
                        <select-form
                            :select-data="['10줄 보기', '20줄 보기', '50줄 보기', '100줄 보기']"
                            class="float-right"
                        ></select-form>
                    </div>
                </div>
                <b-pagination
                    v-model="templateListPagingInfo.page"
                    :per-page="templateListPagingInfo.limit"
                    :total-rows="templateListPagingInfo.totalItems"
                    align="center"
                    aria-controls="my-table"
                    first-class="first"
                    last-class="last"
                    next-class="next"
                    prev-class="prev"
                    @change="handlerPagenation($event, 'templateList')"
                ></b-pagination>
            </div>
        </template>

        <contract-preview-dlg
            v-if="contractPreviewPop"
            :show="contractPreviewPop"
            :templateId="selectedTemplateId"
            :close="handleCloseContractPreview"
        ></contract-preview-dlg>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import BtnLoadingSpinner from '../../../components/BtnLoadingSpinner';
import moment from 'moment';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { pagingInfo } from '@/assets/js/common';
import { Utils } from '@/assets/js/utils';
import XLSX from 'xlsx';
import ContractPreviewDlg from '../../../components/ContractPreviewDlg';

export default {
    name: 'ElectronicTemplateMange',
    mixins: [MixinAllowedMenu],
    components: {
        LoadingSpinner,
        BtnLoadingSpinner,
        ContractPreviewDlg
    },
    props: [],
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        centerStaffId() {
            const { getters } = this.$store;
            return getters['auth/staffId'];
        },
    },
    watch: {},
    created() {},
    mounted() {
        this.init();
    },
    data() {
        return {
            centerId: 0,

            submenus: [
                { name: 'SettingElectronicContractManage', label: '계약 관리' },
                { name: 'SettingElectronicExternalDocument', label: '외부 문서' },
                { name: 'SettingElectronicTemplateManage', label: '템플릿 관리' },
                { name: 'SettingElectronicSignature', label: '서명' },
                { name: 'SettingElectronicSetting', label: '설정' },
            ],

            isLoading: false,

            templateList: [],
            templateListPagingInfo: { ...pagingInfo },
            // templateListSortColumn: "e_upd_dt",
            //templateListSortColumn: "e.use_yn",
            templateListSortColumn: "e.upd_dt",
            templateListSortType: 'DESC',

            selectedAll: false,
            selected: [],

            startDate: this.initStartDate(),
            endDate: this.initEndDate(),
          period: 'year', // 등록일 조회
            searchStr: '',
            searchDivision: 1,
            searchMethod: '',
            searchStatus: 0,
            copiedList: [],

            selectViewMore: [
                { type: 1, name: '업데이트' },
                { type: 2, name: '다운로드' },
                { type: 3, name: '발송취소' },
                { type: 4, name: '기한연장' },
            ],

            contractPreviewPop: false,
            selectedTemplateId: 0,
        };
    },
    methods: {
        // 초기화
        async init() {
            this.isLoading = true;

            this.centerId = parseInt(this.cId); // 센터id

            this.setSubMenu();

            this.onSearchList();

            this.isLoading = false;
        },

        onShowContract(index) {
            this.selectedTemplateId = this.templateList[index].e_id;

            this.contractPreviewPop = true;
        },

        handleCloseContractPreview() {
            this.contractPreviewPop = false;
        },

        setSubMenu() {
            this.submenus[0].valid = this.isAllowed('ME', 6) || this.isAllowed('ME', 7);
            this.submenus[1].valid = this.isAllowed('ME', 6) || this.isAllowed('ME', 7);
            this.submenus[2].valid = this.isAllowed('ME', 6);
            this.submenus[3].valid = this.isAllowed('ME', 6);
            this.submenus[4].valid = this.isAllowed('ME', 6);
        },

        setSearchDivision(newValue) {
            this.searchDivision = newValue;
        },

        periodc(newValue) {
            this.period = newValue;
            if (newValue === 'thisMonth') {
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'today') {
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'lastWeek') {
                this.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'threeMonth') {
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'sixMonth') {
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'year') {
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            }

            this.templateListPagingInfo.page = 1;
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
        // if (this.count < this.first) {
        //   this.count += 1;
        //   return;
        // }
        // this.startDate = val;
        // this.templateListPagingInfo.page = 1;
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
        // if (this.count < this.first) {
        //   this.count += 1;
        //   return;
        // }
        // this.endDate = val;
        // this.templateListPagingInfo.page = 1;
        },

        async onSearch() {
            this.templateListPagingInfo.page = 1;
            this.onSearchList();
        },

        async onSearchList() {
            try {
                this.isLoading = true;

                const { data } = await this.getDocumentList();

                this.setPageParams(data);
                this.templateList = data.items;

                // this.copiedList = [];

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },
        getDocumentList(isAll = false) {
            // 스웨거: Lesson Manage Paging 목록 조회
            let params = {
                // startDate: moment(this.startDate).format('YYYYMMDD'),
                // endDate: moment(this.endDate).format('YYYYMMDD'),
                searchDivision: this.searchDivision,
                searchStr: this.searchStr,
                searchMethod: this.searchMethod,
                contractSendListSortColumn: this.templateListSortColumn,
                contractSendListSortType: this.templateListSortType,
                ...this.templateListPagingInfo,
            };

            if (isAll) {
                params.page = 1;
                params.limit = 99999;
            }

            return api.get(`/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/template`, {
                params,
            });
        },

        setPageParams(data) {
            this.templateListPagingInfo.totalPages = data.meta.totalPages;
            this.templateListPagingInfo.page = data.meta.currentPage;
            this.templateListPagingInfo.totalItems = data.meta.totalItems;
            this.templateListPagingInfo.itemCount = data.meta.itemCount;
        },

        onSearchDivision(type) {
            this.searchDivision = type;

            this.templateListPagingInfo.page = 1;
        },

        onSearchMethod(type) {
            this.searchMethod = type;

            this.templateListPagingInfo.page = 1;
        this.onSearch();
        },

        // 이용권명 컬럼 클릭시
        onClickSendDt() {
            this.templateListSortColumn = 'e_upd_dt';
            if (this.templateListSortType === '' || this.templateListSortType === 'DESC') {
                this.templateListSortType = 'ASC';
            } else {
                this.templateListSortType = 'DESC';
            }

            this.onSearchList();
        },

        // 검색어 입력 처리
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }

            this.onSearch();
        },

        onConditionInit() {
            this.startDate = this.initStartDate();
            this.endDate = this.initEndDate();
        this.period = 'year';
            this.searchStr = '';
            this.searchDivision = 1;
            this.searchMethod = '';
            this.searchStatus = 0;

            // this.onSearchList();
        },

        // 페지 변경 Handler
        handlerPagenation(event, pagingType) {
            if (pagingType === 'templateList') {
                this.templateListPagingInfo.page = event;
                this.onSearchList();
            }
        },

        async deleteDocument() {
            if (this.selected.length == 0) {
                alert('템플릿을 선택해 주세요.');
                return;
            }

            if (!confirm('삭제 하시겠습니까?')) return;

            const params = {
                selectedIds: this.templateList
                    .filter((item, index) => this.selected.indexOf(index) >= 0)
                    .map((i) => i.e_id)
                    .toString(),
            };

            await api.delete(`/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/template`, {
                params,
            });

            this.selected = [];

            this.onSearchList();
        },

        registerDocument() {
            this.$router.push({ name: 'SettingElectronicTemplateDetail', query: { templateId: 0 } });
        },

        async onCopy(index) {
            if (!confirm('템플릿을 복사하시겠습니까?')) return;

            const { data } = await api.post(
                `/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/template/copy/${this.templateList[index].e_id}`
            );
            if (data) {
                let flag = false;
                this.copiedList.map((t) => {
                    if (t.index == index) {
                        flag = true;
                        t.count++;
                    }
                });

                if (!flag) {
                    this.copiedList.push({ index: index, count: 1 });
                }

                alert('템플릿이 복사되었습니다.');

                this.onSearchList();
            }
        },

        onModify(index) {
            this.$router.push({
                name: 'SettingElectronicTemplateDetail',
                query: { templateId: this.templateList[index].e_id },
            });
        },
        // 검색 종료일
        initEndDate() {
            const endDate = moment().endOf('month').format('YYYY-MM-DD');
            return endDate;
        },

        // 검색 시작일
        initStartDate() {
            const startDate = moment().startOf('month').format('YYYY-MM-DD');
            return startDate;
        },

        checkedAll() {
            // 전체 선택 기능
            this.selected = [];
            if (!this.selectedAll) {
                for (const i in this.templateList) {
                    this.selected.push(parseInt(i));
                }
            }
        },

        getTemplate(templateSendId) {
            return api.get(
                `/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/template/${templateSendId}`
            );
        },

        getElementHtml(item) {
            let html = ``;
            html += `
            <div class='contract-content-info' style='margin: 0; padding: 0; page-break-before: auto;'>
                <div class='contract-title-input' style='margin-top: 20px; margin-bottom: 20px; background-color: white; page-break-inside: avoid; min-height: 1px;'>
                    ${item.contractTitle}
                </div>
                <div class='contract-info-title'>수신인 정보</div>
                <div class='contract-info-sub-title'>이름</div>
                <div class='contract-info-sub-title'>연락처</div>
                <div class='contract-info-title'>이용권 정보</div>
                <div class='contract-info-title'>약관</div>`;

            item.templateInfo.map((it, i) => {
                html += `<div style='padding: 10px 10px 0 10px'>`;

                const content = it.content.replace(new RegExp('\n', 'g'), '<br>');

                if (it.type == 1) {
                    html += `
                    <div>
                        <div class='contract-info-sub-title' style='display: flex'>
                            <div style='flex: 1;'>${it.title}</div>
                        </div>
                        <div class='contract-info-sub-title area' style='resize: none; background-color: transparent'>${content}</div>
                    </div>
                  `;
                } else {
                    html += `
                    <div style='display: flex'>
                        <div style='flex: 1;'>
                            <div class='contract-info-sub-title' style='display: flex'>
                                <div style='flex: 1;'>${it.title}</div>
                            </div>
                            <div class='contract-info-sub-title area' style='resize: none; background-color: transparent'>${content}</div>`;

                    it.options.map((jt, j) => {
                        html += `
                        <div style='display: flex; align-items: center; margin-top: 10px'>
                            <div class='com-check'>
                                <input
                                    :id='agree-check-${i}-${j}'
                                    name='check-c1'
                                    ` + (jt.checked ? "checked" : "") + `
                                    type='checkbox'
                                    disabled
                                />
                                <label :for='agree-check-${i}-${j}' class='agree-option'></label>
                            </div>
                            <div class='agree-option-input'>${jt.title}</div>
                        </div>
                      `;
                    });

                    html += `
                        </div>
                    </div>`;
                }

                html += `</div>`;
            });

            html += `
                    <div style='display: flex'>
                        <div class='contract-info-title' style='flex: 1;'>${this.$options.filters.dateFormatFilter2(
                            new Date()
                        )}</div>
                        <div style='width: 300px; margin-top: 40px;'>
                            <div style='display: flex; align-items: center'>
                                <div class='contract-info-person'>수신인</div>
                                <div class='contract-info-signature no-image'>(서명)</div>
                            </div>
                            <div style='display: flex; align-items: center; margin-top: 10px;'>
                                <div class='contract-info-person'>발신인</div>
                                <div class='contract-info-signature no-image'>(서명)</div>
                            </div>
                        </div>
                    </div>
                  </div>
              `;

            return html;
        },

        getPDFContent(index, returnBuffer = false) {
            return Promise.all([this.getTemplate(this.templateList[index].e_id)]).then((response) => {
                if (response && response.length > 0) {
                    const list = response[0].data;

                    let element = document.createElement('div');
                    element.style.padding = '20px';

                    element.innerHTML = this.getElementHtml(list);

                    
                    let opt = {
                        filename: this.templateList[index].e_contract_title + '.pdf',
                        enableLinks: true,
                        image: { type: 'jpeg', quality: 0.98 },
                        pagebreak: { mode: ['avoid-all', 'css', 'legacy']},
                        html2canvas: {
                          scale: 2,
                          scrollY: 0,
                          useCORS: true,
                          // width: 800,
                          letterRendering: false,
                          allowTaint: false, //useCORS를 true로 설정 시 반드시 allowTaint를 false처리 해주어야함
                        },
                        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                    };

                    if (returnBuffer) {
                      html2pdf().from(element).set(opt).output();
                    } else {
                      html2pdf().from(element).set(opt).save();
                    }
                }
            });
        },

        async onDownloadDocument(index) {
            this.getPDFContent(index);
        },

        async onSaveUseState(index, checked) {
            if (checked) {
                if (!confirm('템플릿을 사용 상태로 변경하시겠습니까?')) {
                    const checkAgree = this.$refs.refCheckAgree;
                    checkAgree[index].checked = !checked;
                    return;
                }
            } else {
                if (!confirm('템플릿을 숨김 상태로 변경하시겠습니까?')) {
                    const checkAgree = this.$refs.refCheckAgree;
                    checkAgree[index].checked = !checked;
                    return;
                }
            }
            try {
                this.isLoading = true;

                await api.put(`/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/template/use`, {
                    id: this.templateList[index].e_id,
                    state: checked,
                });

                this.templateList[index].e_use_yn = !this.templateList[index].e_use_yn;

                this.onSearch();
                alert('상태 변경되었습니다.');

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        // Excel Download
        async excelDownload() {
            const { data } = await this.getDocumentList(true);

            const excelDownloadArray = [];
            data.items.forEach((item) => {
                const temp = {};
                temp['수정일시'] = this.$options.filters.timestampFilter2(item.e_upd_dt);
                temp['구분'] = this.$options.filters.getContractMemberType(item.e_contract_member_type);
                temp['계약서명'] = item.e_contract_title;

                excelDownloadArray.push(temp);
            });
            const ws = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            const wscols = [{ wch: 30 }, { wch: 20 }, { wch: 20 }];
            ws['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            ws['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, '계약서템플릿목록');
            XLSX.writeFile(wb, `계약서템플릿_${new Date().toLocaleDateString().toString()}.xlsx`);
        },
    },
};
</script>
<style lang="scss"></style>
